module.exports = __webpack_public_path__ + "img/UsersGroupRounded2.aeec71df.svg";